import {combineReducers} from '@modifi/redux'
import updateReducer from './store/update'

export default combineReducers({
  update: updateReducer,
})
